var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedinBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 27.9863C6.04414 27.9863 0 21.9422 0 14.4863C0 7.03047 6.04414 0.986328 13.5 0.986328C20.9559 0.986328 27 7.03047 27 14.4863C27 21.9422 20.9559 27.9863 13.5 27.9863Z",
    fill: "#9DD1FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.173 11.4712H7.37793V20.4948H10.173V11.4712Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.76131 10.2937C9.67645 10.2937 10.4142 9.5488 10.4142 8.62658C10.4142 7.70435 9.67645 6.95947 8.76131 6.95947C7.84618 6.95947 7.1084 7.70435 7.1084 8.62658C7.1084 9.5488 7.84618 10.2937 8.76131 10.2937Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6425 15.7634C14.6425 14.4936 15.2242 13.7416 16.3451 13.7416C17.3737 13.7416 17.8632 14.4652 17.8632 15.7634V20.5022H20.6441V14.7844C20.6441 12.3653 19.2749 11.1948 17.3595 11.1948C15.4441 11.1948 14.6425 12.6846 14.6425 12.6846V11.4715H11.9609V20.4951H14.6425V15.7563V15.7634Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinBlue);
export default __webpack_public_path__ + "static/media/linkedin-blue.2e2b6e5f75468d393b33ab23c9410df1.svg";
export { ForwardRef as ReactComponent };